export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

export const FR_PHONE_REGEX = /^(?:(?:\+|00)33|0)[1-9]\d{8}$/;

export function isValidFrenchPhone(phone: string): boolean {
  const normalized = phone.replaceAll(/\s/g, '').replaceAll('.', '').replaceAll('-', '');
  return FR_PHONE_REGEX.test(normalized);
}
